import { Link } from 'react-router-dom';
import { NavigateRoutesEnum } from '@routing/routesEnum';
import faqDog from '@assets/images/faq-dog.webp';



const Faq = (): JSX.Element => {

	return (
		<div className="app-page faq-page">
			
			<h1>Nejčastější dotazy (FAQ)</h1>

			<div className='faq-item'>
				<h2>V čem jsou VETlímce výjimečné?</h2>
				<p>Oproti klasickým plastovým límcům přinášejí mnoho výhod a&nbsp;zvířeti přinášejí fyzický i psychický komfort:</p>
				<ul>
					<li>zamezují v kontaktu s&nbsp;ránou</li>
					<li>nebrání v prostorové orientaci</li>
					<li>umožňují bezproblémové krmení</li>
					<li>zajišťují klidný spánek</li>
					<li>nedráždí pokožku, snižují riziko zapařenin</li>
				</ul>
			</div>

			<div className='faq-item'>
				<h2>Jsou VETlímce bezpečné?</h2>
				<p>Ano. Bezpečnost zvířat je na&nbsp;prvním místě. Na&nbsp;jejich vývoji jsme několik měsíců spolupracovali s&nbsp;veterinárními lékaři, ladili detaily a&nbsp;ujišťovali se o tom, že s&nbsp;jejich pomocí lze rekonvalescenci zvládnout s&nbsp;minimálním stresem a&nbsp;hlavně bezpečně.</p>
			</div>
			
			<div className='faq-item'>
				<h2>Na&nbsp;jaká zranění lze VETlímce použít?</h2>
				<p>Límec můžeme bez obav doporučit na&nbsp;zranění v&nbsp;oblasti břicha, slabin, trupu, zad a&nbsp;předních končetin. U zadních končetin, konkrétně oblasti tlapek, je to trochu složitější. Zde postupujeme individuálně a&nbsp;přihlížíme k&nbsp;tělesné stavbě zvířete a&nbsp;dalším vlastnostem. Můžete si být jisti, že Vám vždy narovinu řekneme, jak se věci mají a&nbsp;případně límec nedoporučíme.</p>
			</div>
			
			<div className='faq-item'>
				<h2>Jak si mohu límec objednat?</h2>
				<p>Velká přidaná hodnota našich límců spočívá v&nbsp;tom, že se Vám vždy dostane individuálního poradenství a&nbsp;Vy si tak můžete být jisti, že máte produkt, který přesně odpovídá nárokům Vašeho mazlíčka. VETlímce můžete zakoupit dvojím způsobem, přes náš objednávkový&nbsp;formulář umístěný na&nbsp;našem webu, na&nbsp;který zareagujeme s konkrétní nabídkou, nebo v&nbsp;síti některé z&nbsp;partnerských veterinárních ordinací, kde Vám s&nbsp;výběrem rádi poradí. Jejich seznam naleznete v&nbsp;sekci <Link to={NavigateRoutesEnum.salesNetwork}>Partnerské&nbsp;veteriny</Link>.</p>
				<p>Naše produkty odesíláme skrze Zásilkovnu a&nbsp;DPD, v&nbsp;případě expresního dodání prostřednictvím soukromých dopravců. Možnost osobního vyzvednutí samozřejmostí po&nbsp;předchozí domluvě. Límce standardních velikostí odesíláme obratem. Na&nbsp;výrobu individuálních velikostí potřebujeme chvíli navíc, ale snažíme se&nbsp;odesílat co&nbsp;nejrychleji můžeme - většinou to&nbsp;zvládneme do&nbsp;dvou dnů.</p>
			</div>

			<div className='faq-item'>
				<h2>Proplácí VETlímce pojišťovna?</h2>
				<p>Ano, VETlímce proplácejí vybrané pojišťovny, informujte se&nbsp;u&nbsp;svého poskytovatele pojištění na&nbsp;podmínky a&nbsp;výhody, které&nbsp;můžete čerpat&nbsp;dle platných pojistných podmínek.</p>
			</div>

			<div className='faq-item'>
				<h2>Kolik stojí VETlímec?</h2>
				<p>Cena VETlímce se&nbsp;odvíjí od&nbsp;tělesné konstituce Vašeho parťáka. Objednávkový formulář Vám přímo vypočítá přesnou cenu&nbsp;dle Vámi zadaných parametrů. Orientačně se&nbsp;cena VETlímce pohybuje následovně:</p>
				<p>Malý pes - od&nbsp;1250&nbsp;Kč s DPH</p>
				<p>Střední pes - od&nbsp;1400&nbsp;Kč s DPH</p>
				<p>Velký pes - od&nbsp;1700&nbsp;Kč s DPH (maximální částka 2200&nbsp;Kč s DPH)</p>
			</div>
			
			<div className='faq-image'>
				<img src={faqDog} alt='faq-dog-photo' />	
			</div>

		</div>
	);
};

export default Faq;